'use client'

import { ReactNode, useEffect } from 'react'
import { Cell, Icon, Validation } from '@vinted/web-ui'
import { Pencil24, Plus24 } from '@vinted/monochrome-icons'
import { isEmpty } from 'lodash'

import { AddressModel } from 'types/models/address'

import { useTranslate } from '@marketplace-web/shared/i18n'

import AddressDetails from 'components/AddressDetails'
import { scrollIntoViewById } from '@marketplace-web/domain/complaints'

type Props = {
  address: AddressModel | null | undefined
  error: string | null
  photo?: ReactNode
  handleEditAddressOpen: () => void
}

export enum FieldName {
  Address = 'request_return_address',
}

const Address = ({ address, error, photo, handleEditAddressOpen }: Props) => {
  const translate = useTranslate('checkout.address')

  useEffect(() => {
    if (!error) return

    scrollIntoViewById(FieldName.Address)
  }, [error])

  function renderEmptyAddress() {
    return (
      <Cell
        type={Cell.Type.Navigating}
        title={translate('empty.title')}
        suffix={<Icon name={Plus24} testId="address-plus-icon" />}
        theme="transparent"
        onClick={handleEditAddressOpen}
        validation={<Validation text={error} theme="warning" />}
      />
    )
  }

  function renderAddress() {
    return (
      <AddressDetails
        prefix={photo}
        address={address}
        type={Cell.Type.Navigating}
        suffix={
          <Icon name={Pencil24} color={Icon.Color.GreyscaleLevel2} testId="address-pencil-icon" />
        }
        onClick={handleEditAddressOpen}
        validation={error}
      />
    )
  }

  const renderContent = () => (isEmpty(address) ? renderEmptyAddress() : renderAddress())

  return <div id={FieldName.Address}>{renderContent()}</div>
}

export default Address
